import { EditOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import {
  EDIT_POSITION_PATH,
  U_ACTION,
  U_DESCRIPTION,
  U_KEY,
  U_NAME,
  U_ROLES,
} from '@app/constants';
import type { NPositions } from '@app/types';

export const adaptDataToTable = (
  positions: NPositions.ModelPosition[],
  handleEdit: (id: number) => void,
  hasUserRightToEditPosition: boolean
) => {
  return positions.map((position) => {
    const { Id, Name, Description, Roles } = position;

    return {
      [U_KEY]: String(Id),
      [U_NAME]: (
        <Link to={`${EDIT_POSITION_PATH}?id=${Id}`} data-testid="position-name">
          {Name}
        </Link>
      ),
      [U_DESCRIPTION]: (
        <span data-testid="position-description">{Description}</span>
      ),
      [U_ROLES]: (
        <span data-testid="position-roles">
          {Roles?.map(({ Name }) => Name).join(', ')}
        </span>
      ),
      [U_ACTION]: (
        <>
          {hasUserRightToEditPosition ? (
            <Space>
              <Tooltip title="Редактировать">
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(Id)}
                  data-testid="edit-position"
                />
              </Tooltip>
            </Space>
          ) : (
            <></>
          )}
        </>
      ),
    };
  });
};
